var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platon-table-no-data"},[_vm._v(" "+_vm._s(_vm.$l("platon.table_no_data", "Жадвалда маълумот йўқ"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }